import config from "../_helpers/config";
import { postAsync } from "../_helpers/adapters";


const baseUrl = `${config.apiUrl}/newsletter`;  

export const sendNewsletter = async (data) => {
  const url = `${baseUrl}/send`;
  return await postAsync(url, data);
}